import { render, staticRenderFns } from "./PortfolioDividends.vue?vue&type=template&id=6ed7cf78&"
import script from "./PortfolioDividends.vue?vue&type=script&lang=js&"
export * from "./PortfolioDividends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports